export default __webpack_public_path__ + "static/media/kanye-hottub.616a44fe.svg";